import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    /* Suppression de la page home > si les clients l'ont en favoris, les rediriger vers login */
    {
        path: 'home',
        redirectTo: '/login',
        pathMatch: 'full',
    },
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
